import type { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { AccessLevelModel } from './types';
import type { UserRole } from 'shared/types/userRole';
import { findUserAccessLevelInIssueAccesses } from './findUserAccessLevel';
import type { UserAccessRecord } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { isViewer } from 'shared/domain/role/isViewer';
import { isAtLeastManager } from 'shared/domain/issue/access/isAtLeastManager';

export function createAccessLevel(
  userAccesses: UserAccess[],
  userId: string,
  userRole: UserRole
): AccessLevelModel {
  if (isAtLeastManager(userRole)) {
    return AccessLevelModel.EDIT;
  } else {
    return findUserAccessLevelInIssueAccesses(
      userAccesses,
      userRole,
      userId
    );
  }
}

export function createAccessLevelFromUserAccesses(
  userAccesses: UserAccess[],
  userId: string,
  userRole: UserRole
): AccessLevelModel {
  if (isAtLeastManager(userRole)) {
    return AccessLevelModel.EDIT;
  } else {
    const userAccess = userAccesses.find(
      (access) => access.accessingUser === userId
    );

    if (userAccess) {
      return userAccess.accessLevel;
    } else {
      return isViewer(userRole)
        ? AccessLevelModel.READ
        : AccessLevelModel.NONE;
    }
  }
}

export function createAccessLevelFromAccessRecord(
  userAccesses: UserAccessRecord,
  userId: string,
  userRole: UserRole
): AccessLevelModel {
  if (isAtLeastManager(userRole)) {
    return AccessLevelModel.EDIT;
  } else {
    const userAccess = userAccesses[userId];
    if (userAccess && !userAccess.deleted) {
      return userAccess.accessLevel;
    } else {
      return isViewer(userRole)
        ? AccessLevelModel.READ
        : AccessLevelModel.NONE;
    }
  }
}
